import { useEffect, useMemo } from 'react'
import { Alert } from 'flowbite-react'
import { Navigate, useLocation } from 'react-router-dom'
import ExportFilters from '@components/exports/ExportFilters'
import ExportHistoryTable from '@components/exports/ExportHistoryTable'
import MainHeader from '@components/main/MainHeader'
import { useAuthStore } from '@stores/authStore'
import { useExportStore } from '@stores/exportStore'

function ExportsPage() {
  const location = useLocation()
  const session = useAuthStore((state) => state.session)
  const sessionError = useAuthStore((state) => state.error)
  const loadSession = useAuthStore((state) => state.loadSession)

  const availableGames = useExportStore((state) => state.availableGames)
  const error = useExportStore((state) => state.error)
  const filters = useExportStore((state) => state.filters)
  const isHistoryLoading = useExportStore((state) => state.isHistoryLoading)
  const isStarting = useExportStore((state) => state.isStarting)
  const jobs = useExportStore((state) => state.jobs)
  const loadInitialData = useExportStore((state) => state.loadInitialData)
  const setFilters = useExportStore((state) => state.setFilters)
  const startExport = useExportStore((state) => state.startExport)

  useEffect(() => {
    void loadSession()
  }, [loadSession])

  const canExport = useMemo(() => {
    return Boolean(
      session?.menu.topItems.some(
        (item) => item.title === 'Экспорт' && item.url === '/exports/',
      ),
    )
  }, [session])

  useEffect(() => {
    if (session?.authenticated && canExport) {
      void loadInitialData()
    }
  }, [canExport, loadInitialData, session?.authenticated])

  if (session && !session.authenticated) {
    const next = `${location.pathname}${location.search}${location.hash}`
    return <Navigate to={`/login?next=${encodeURIComponent(next)}`} replace />
  }

  return (
    <main className="min-h-svh bg-slate-50 text-slate-950 dark:bg-zinc-950 dark:text-slate-100">
      <MainHeader />

      <section className="min-w-0 overflow-y-auto p-6 max-[820px]:p-4">
        <div className="mx-auto grid w-full max-w-6xl gap-5">
          <div>
            <h1 className="m-0 text-2xl font-semibold tracking-normal text-slate-950 dark:text-slate-100">
              Экспорт
            </h1>
            <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">
              Настройте параметры и запустите выгрузку игроков по email.
            </p>
          </div>

          {sessionError ? <Alert color="failure">{sessionError}</Alert> : null}

          {session && !canExport ? (
            <Alert color="failure">Нет доступа к экспорту.</Alert>
          ) : null}

          {error ? <Alert color="failure">{error}</Alert> : null}

          {canExport && session ? (
            <>
              <ExportFilters
                availableGames={availableGames}
                isStarting={isStarting}
                values={filters}
                onChange={setFilters}
                onSubmit={(values) => startExport(values, session.csrfToken)}
              />

              <ExportHistoryTable
                jobs={jobs}
                isLoading={isHistoryLoading}
              />
            </>
          ) : null}
        </div>
      </section>
    </main>
  )
}

export default ExportsPage
